import PropTypes from "prop-types";
import React from "react";
import { DragSource, DropTarget } from "react-dnd";

import TargetCard from "./target-card.js";

const cardSource = {
  beginDrag(props) {
    return {
      item: props.item,
      index: props.index,
    };
  },
};

const cardTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    if (dragIndex === hoverIndex) {
      return null;
    }

    props.moveCard(dragIndex, hoverIndex);
    monitor.getItem().index = hoverIndex;
  },
};

function collectSource(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

function collectTarget(connect) {
  return {
    connectDropTarget: connect.dropTarget(),
  };
}

class DraggableTargetCard extends React.Component {
  static get displayName() {
    return "DraggableTargetCard";
  }

  static get propTypes() {
    return {
      connectDragSource: PropTypes.func.isRequired,
      connectDropTarget: PropTypes.func.isRequired,
      index: PropTypes.number.isRequired,
      isDragging: PropTypes.bool.isRequired,
      item: PropTypes.object.isRequired,
      onChangeDuration: PropTypes.func.isRequired,
      onDelete: PropTypes.func.isRequired,
      moveCard: PropTypes.func.isRequired,
    };
  }

  render() {
    const {
      connectDragSource,
      connectDropTarget,
      index,
      item,
      onChangeDuration,
      onDelete,
    } = this.props;
    return connectDragSource(
      connectDropTarget(
        <div
          className="draggable-content"
          ref={(node) => {
            this.node = node;
          }}
        >
          <div className="draggable-content-index">{index + 1}</div>
          <button
            className="draggable-content-delete"
            onClick={() => onDelete(item)}
          >
            <i className="fa fa-lg fa-times-circle" />
          </button>
          <TargetCard
            id={item.id}
            details={{
              name: item.name,
              icon: item.url,
              type: item.type,
              duration: item.duration,
            }}
            size="xs"
            showDuration={true}
            onChangeDuration={(d) => onChangeDuration(d, item)}
          />
        </div>,
      ),
    );
  }
}

const connectedDropTarget = new DropTarget(
  "DraggableTargetCard",
  cardTarget,
  collectTarget,
)(DraggableTargetCard);

module.exports = new DragSource(
  "DraggableTargetCard",
  cardSource,
  collectSource,
)(connectedDropTarget);
